export const secondsInHour = 3600;
export const secondsInMinute = 60;
export const minutesInHour = 60;
export const daysInWeek = 7;
export const millisecondsInSecond = 1000;
export const millisecondsInMinute = 60000;
export const millisecondsInHour = 3600000;
export const wholeDayInSeconds = 24 * secondsInHour;
